<template>
    <div class="sales-items" v-if="crmProjects != null">

        <!-- production-item -->

        <div class="sale-item" v-for="(item, index) in projectItems" :data-them="item.project_them.value" :data-part-name="item.new_start_part_name" :data-them-title="item.project_them.label" :data-them-custom="item.custom_theme" :data-name="item.project_name.slug" :key="item.project_name.slug" :class="{animate : cardAnimate}">
            <!-- :class="{animate : cardAnimate}" -->
            <div class="inner" :class="{newOver: item.project_site_type == 'form'}">
                <!-- :to="{ name : 'sale-card' , params:{id : item.project_name.slug}}" -->
                <a :href="'sales/' + item.project_name.slug" class="link-to-page" @click.prevent="checkForSite(item.project_name.slug, item)">
                    <div class="item-img">
                        <img :src="item.project_img" alt="">
                        <!-- <p v-if="item.project_name.slug == 'skypark'"><span>СКОРО!</span><br>САМАЯ ОЖИДАЕМАЯ ПРЕМЬЕРА</p> -->
                    </div>
                </a>
                <div class="item-desc">
                    <div class="item-logo" @click.prevent="checkForSite(item.project_name.slug, item)">
                        <img :src="item.logo_color" alt="" @click="openLinkLogo(item)">
                    </div>
                    <div class="item-list-info">
                        <ul>
                            <li>
                                <div class="left">Стоимость <span>м²</span></div>
                                <div class="right" v-if="item.project_stie_flats_filter_init == 'true'">
                                    <p v-if="item.project_stie_shablon_price_flats_init == 'true' && getCRMprojectInfo(item.crm_code, 'price') != false"><span>от</span> {{getCRMprojectInfo(item.crm_code, 'price')}} <span>тг.</span></p>
                                    <p v-else class="light">по запросу</p>
                                </div>
                                <div class="right" v-else>
                                    <p class="light">по запросу</p>
                                </div>
                            </li>
                            <li>
                                <div class="left">Квартир в наличии</div>
                                <div class="right" v-if="item.project_stie_flats_filter_init == 'true'">
                                    <p v-if="getCRMprojectInfo(item.crm_code, 'flats') != false">{{getCRMprojectInfo(item.crm_code, 'flats')}}</p>
                                    <p v-else class="light">по запросу</p>
                                </div>
                                <div class="right" v-else>
                                    <p class="light">по запросу</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="adres" v-html="item.project_adres"></div>
                    <div class="item-btns">
                        <a href="#" @click.prevent="navigationToFlatsFilter(item.crm_code) " v-if="item.project_stie_flats_filter_init == 'true'">СМОТРЕТЬ КВАРТИРЫ</a>
                        <a href="#" @click.prevent="openForm(index)" v-if="!isMobile && item.project_stie_flats_filter_init !== 'true'">ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ</a>
                        <a href="#" @click.prevent="getConsultation()" v-if="isMobile && item.project_stie_flats_filter_init !== 'true'">КОНСУЛЬТАЦИЯ</a>
                    </div>
                </div>
                <div class="btn-to-login" v-if="item.project_site_type == 'form'">
                    <a href="#" @click.prevent="openForm(index)">Зарегистрироваться</a>
                </div>
                <div class="btn-to-favorite" v-if="cardAnimate">
                    <a href="#" @click.prevent="sendToFavorite(item.project_name.name), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.project_name.name)}" class="favorite-link">
                        <svg-icon icon-class="star" className="icon-star"/>
                    </a>
                </div>
                <!-- v-if="item.project_site_type == 'form' || item.project_stie_flats_filter_init == 'false'" -->
                <formSignupProject  :options="[{project_name: item.project_name.name, 'index': index}]"></formSignupProject>
            </div>
        </div>
        
        <!-- {{projectItems}} -->
        <!-- {{projectFilterCity}} - Город -->
    </div>
</template>

<script>
    import formSignupProject from '@/components/forms/form-signup-project.vue'
    import saleItemBaner from '@/components/sales/sale-item-baner.vue'
    // import newYear2021 from '@/components/newyear/newyear.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-item',
        components: {
            formSignupProject,
            saleItemBaner,
            // newYear2021,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                banerArr: null,
                isMobile: false,
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
            cardAnimate: 'loadCardAnimateStatus',
            projectItemsDefault: 'loadProjectItemsDefault',
            banerSystem: 'loadBanerSystem',
            projectFilterCity: 'loadProjectItemsFilterCity',
            crmProjects: 'loadCrmProjects',
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            getCRMprojectInfo(id, key) {
                var arr = this.crmProjects;
                var result;
                // console.log(key, 'key')
                // console.log(arr, 'arr');
                // console.log(id, 'id')
                if (id != null) {
                    var filter = arr.filter(item => {
                        return item.code == id
                    });
                    // console.log(filter, id)
                    if (filter.length > 0) {
                        if (key == 'price') {
                            if (filter[0].minMeterPrice != 0 && filter[0].minMeterPrice != null) {
                                result = this.getNumber(filter[0].minMeterPrice);
                            } else {
                                return false;
                            }
                        } else {
                            if (filter[0].apartmentsQuantity != 0 && filter[0].apartmentsQuantity != null) {
                                result = filter[0].apartmentsQuantity;
                            } else {
                                return false;
                            }
                        }
                        return result;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            sendToFavorite(name) {
                // console.log(name, 'NAME');
                // Получаем уже хранившиеся комплексы если есть из LocalStorage
                var exist = localStorage.getItem('favorite_projects');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такое имя в Storage
                var finder = exist.find(item => item == name);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(name);
                    localStorage.setItem('favorite_projects', exist);
                    this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != name
                    })
                    localStorage.setItem('favorite_projects', filterExist);
                    this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(filterExist);
                }
            },
            checkProjectFavorite(name) {
                var items = localStorage.getItem('favorite_projects');
                items = items ? items.split(',') : [];
                this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == name);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
                // Фильтр для избранных
                if (this.routerName == 'favorite-projects') {
                    var data = this.projectItemsDefault;
                    var favorite = localStorage.getItem('favorite_projects');
                    favorite = favorite ? favorite.split(',') : [];
                    var i;
                    var n;
                    var favoriteItems = [];
                    for (i=0; i < favorite.length; i++) {
                        for (n=0; n < data.length; n++) {
                            if (data[n].project_name.name == favorite[i]) {
                                favoriteItems.push(data[n])
                            }
                        }
                    }
                    this.$store.commit('cardAnimateSet', false);
                    setTimeout(()=>{
                        this.$store.commit('filterProjectsItems', favoriteItems);
                        this.$store.commit('cardAnimateSet', true);
                    },50);
                }
            },
            checkForSite(name, arr) {
                // console.log(name);
                // console.log(arr);

                // this.$router.push({name : 'sales-app' , params:{id : name} });
                if (arr.project_site_type != null && arr.project_site_type == 'link') {
                    window.open(arr.project_site_in.link, '_blank');
                } else if (arr.project_site_type != null) {
                    this.$router.push({name : 'sales-app' , params:{id : name} })
                } else  {
                    return false;
                }
                // if (arr.turn_on_inside_page == 'false') {
                //     if (arr.project_site.init == 'true') {
                //         window.open(arr.project_site.link, '_blank');
                //     } else {
                //         return false;
                //     }
                // } else if (arr.turn_on_inside_page == 'true') {
                //     
                // } else {
                //     return false;
                // }
            },
            openLinkLogo(arr) {
                if (window.innerWidth > 1024) {
                    if (arr.turn_on_inside_page == 'false') {
                        if (arr.project_site.init == 'true') {
                            window.open(arr.project_site.link, '_blank');
                        } else {
                            return false;
                        }
                    } else if (arr.turn_on_inside_page == 'true') {
                        this.$router.push({name : 'sale-card' , params:{id : name} })
                    } else {
                        return false;
                    }
                }
            },
            openForm(index) {
                // console.log(index);
                this.$store.commit('Open_form_SignUp_Project', index);
                // console.log(this.$store.state.isOpenFormSignUpProject, 'AJAX')
            },
            navigationToFlatsFilter(code) {
                this.$router.push({ path: 'flats', query: { 'complex-code' : code } })
            },
            getConsultation() {
                var data = {
                    'city': this.currentCityArr[0].region,
                    'page': 'sales',
                    'page_key': 'sales',
                }
                this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            },
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.handleResize();
            this.checkResize();
            // this.$store.watch(
            //     (state) => state.projectItemsFilterCity,
            //     (newValue) => {
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/realestate/sale-item.scss';
    @import '@/styles/respond/sales/respond-sale-item.scss';
</style>